import React from "react";
import { AbsoluteFill, useCurrentFrame, interpolate } from "remotion";

export const LotusBloom: React.FC<{ opacity?: number }> = ({ opacity = 1 }) => {
  const frame = useCurrentFrame();

  const bloomProgress = interpolate(frame, [0, 120], [0, 1], { extrapolateRight: "clamp" });
  const sway = Math.sin(frame / 60) * 2;

  const petalLayers = [
    { count: 8, radius: 50, size: 30, color: "#F37021", delay: 0 },
    { count: 10, radius: 70, size: 25, color: "#D4A843", delay: 20 },
    { count: 12, radius: 90, size: 22, color: "#5F259F", delay: 40 },
  ];

  return (
    <AbsoluteFill style={{ opacity, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <svg viewBox="-150 -150 300 300" width="65%" height="65%"
        style={{ position: "absolute", transform: `rotate(${sway}deg)` }}>
        {petalLayers.map((layer, li) => {
          const layerProgress = interpolate(frame, [layer.delay, layer.delay + 60], [0, 1], {
            extrapolateLeft: "clamp", extrapolateRight: "clamp",
          });
          return (
            <g key={li}>
              {Array.from({ length: layer.count }, (_, pi) => {
                const angle = (pi / layer.count) * 360 + li * 15;
                const rad = (angle * Math.PI) / 180;
                const openAngle = layerProgress * 45;
                const petalScale = layerProgress;
                const px = layer.radius * layerProgress * Math.cos(rad);
                const py = layer.radius * layerProgress * Math.sin(rad);

                return (
                  <ellipse key={pi}
                    cx={px} cy={py}
                    rx={layer.size * petalScale * 0.5}
                    ry={layer.size * petalScale}
                    fill={layer.color}
                    opacity={layerProgress * 0.25}
                    transform={`rotate(${angle + openAngle}, ${px}, ${py})`}
                  />
                );
              })}
            </g>
          );
        })}
        {/* Center */}
        <circle cx={0} cy={0} r={12 * bloomProgress}
          fill="#D4A843" opacity={bloomProgress * 0.5}
        />
        <circle cx={0} cy={0} r={6 * bloomProgress}
          fill="#F37021" opacity={bloomProgress * 0.7}
        />
      </svg>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
